import { memo } from 'react'
import Link from 'root/src/client/web/base/Link'
import * as BlackCard from 'root/src/client/web/base/Card/BlackCard/BlackCard'
import { useDropEventCard } from 'root/src/client/web/list/listItemComponents/dropEvent/hooks/useDropEventCard'
import { useListRouteId } from 'root/src/client/web/list/hooks/useListRouteId'
import { DropEventHeader } from 'root/src/client/web/list/listItemComponents/dropEvent/DropEventCardHeader'
import { DropEventSeparator } from 'root/src/client/web/list/listItemComponents/dropEvent/DropEventCardSeparator'
import { DropEventBody } from 'root/src/client/web/list/listItemComponents/dropEvent/DropEventCardBody'
import { DropEventFooter } from 'root/src/client/web/list/listItemComponents/dropEvent/DropEventCardFooter'

const DropEventCard = memo(() => {
	const { dropEvent } = useDropEventCard()

	const listRouteId = useListRouteId()

	return (
		<Link
			routeId={listRouteId}
			routeParams={{ recordId: dropEvent.mnemonicId }}
		>
			<BlackCard.Root>
				<BlackCard.Header style={{ height: '30%', position: 'initial' }}>
					<DropEventHeader />
				</BlackCard.Header>
				<BlackCard.Separator>
					<DropEventSeparator />
				</BlackCard.Separator>
				<BlackCard.Body>
					<DropEventBody />
				</BlackCard.Body>
				<BlackCard.Footer style={{ height: '20%' }}>
					<DropEventFooter />
				</BlackCard.Footer>
			</BlackCard.Root>
		</Link>
	)
})

export default DropEventCard
